function ecommerce(required, extraTypes = {}, strictItems = true) {
  return {
    required,
    types: {
      currency: "currency",
      value: "number",
      items: "array",
      ...extraTypes,
    },
    itemRequired: strictItems ? ["price", "quantity"] : [],
    itemAny: ["item_id", "item_name"],
    itemTypes: {
      item_id: "string",
      item_name: "string",
      price: "number",
      quantity: "number",
    },
  };
}

export const GA4_SCHEMAS = {
  purchase: {
    required: ["transaction_id", "value", "currency", "items"],
    types: {
      transaction_id: "string",
      value: "number",
      currency: "currency",
      items: "array",
    },
    itemRequired: ["price", "quantity"],
    itemAny: ["item_id", "item_name"],
    itemTypes: {
      item_id: "string",
      item_name: "string",
      price: "number",
      quantity: "number",
    },
  },
  refund: {
    required: ["transaction_id"],
    types: {
      transaction_id: "string",
      value: "number",
      currency: "currency",
      items: "array",
    },
    itemRequired: [],
    itemAny: ["item_id", "item_name"],
    itemTypes: {
      item_id: "string",
      item_name: "string",
      price: "number",
      quantity: "number",
    },
  },
  add_to_cart: ecommerce(["currency", "value", "items"]),
  remove_from_cart: ecommerce(["currency", "value", "items"]),
  view_cart: ecommerce(["currency", "value", "items"]),
  begin_checkout: ecommerce(["currency", "value", "items"]),
  add_shipping_info: ecommerce(["currency", "value", "items"], { shipping_tier: "string" }),
  add_payment_info: ecommerce(["currency", "value", "items"], { payment_type: "string" }),
  view_item: ecommerce(["currency", "value", "items"], {}, false),
  view_item_list: ecommerce(["items"], { item_list_id: "string", item_list_name: "string" }, false),
  select_item: ecommerce(["items"], { item_list_id: "string", item_list_name: "string" }, false),
  view_promotion: ecommerce(["items"], { creative_name: "string", promotion_id: "string" }, false),
  select_promotion: ecommerce(["items"], { creative_name: "string", promotion_id: "string" }, false),
  generate_lead: {
    required: [],
    types: { value: "number", currency: "currency" },
  },
  login: {
    required: [],
    types: { method: "string" },
  },
  sign_up: {
    required: [],
    types: { method: "string" },
  },
  search: {
    required: ["search_term"],
    types: { search_term: "string" },
  },
  share: {
    required: ["method", "content_type", "item_id"],
    types: { method: "string", content_type: "string", item_id: "string" },
  },
  select_content: {
    required: ["content_type", "item_id"],
    types: { content_type: "string", item_id: "string" },
  },
};

export const GA4_EVENT_NAMES = Object.keys(GA4_SCHEMAS);
